import type { StaffCoordinationCustomerResponse } from '@/types/apps/staff-coordination-customer.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

type StaffCoordinationCustomerListResponse = ApiResponse<
    PaginatedResult<StaffCoordinationCustomerResponse>
>;

export class StaffCoordinationCustomerService implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/staff-coordination/customer',
    };

    public index(
        params?: QueryParams
    ): Promise<StaffCoordinationCustomerListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }
}
